module.exports = __webpack_public_path__ + "static/media/kahf_brand_banner.5a413c73.jpg";